<template>
    <nav class="bottom-nav">
        <router-link class="px-2" to="/about">
            <fa-icon icon="user-alt" type="fas" />
        </router-link>
        <router-link class="px-2" to="/skills">
            <fa-icon icon="code" type="fas" />
        </router-link>
        <router-link class="px-2" to="/contact">
            <fa-icon icon="envelope" type="fas" />
        </router-link>
    </nav>
</template>

<style lang="scss">
.bottom-nav {
    position: fixed;
    bottom: 0px;
    height: 60px;
    width: 100%;
    background: var(--nav-bg);
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: 0 -2px 10px rgba(10, 25, 47, 0.2);

    a {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        align-items: center;
        color: var(--text-primary);
        text-decoration: none !important;
        transition: all 0.3s ease;

        &:hover {
            background: rgba(100, 255, 218, 0.1);
            color: var(--accent-blue);
        }

        &.router-link-active {
            color: var(--accent-blue);
            background: rgba(100, 255, 218, 0.05);
        }
    }
}
</style>
